import { Component } from '@angular/core';
import { LoaderComponent } from '../../shared/components/loader/loader/loader.component';

@Component({
    selector: 'app-sales-force-sso',
    template: `<app-loader></app-loader>`,
    styleUrls: [],
    imports: [LoaderComponent]
})
export class InboundSsoComponent {

}
